import {
  ADD_AREAFENCE,
  ADD_SOS_CATEGORY,
  GET_AREAFENCE_DATA,
  GET_SOS_CATEGORIES,
  UPDATE_AREAFENCE,
  UPDATE_SOS_CATEGORY,
  UPDATE_SOS_CATEGORIES_STATUS,
  GET_SOS_PROVIDERS,
  GET_SOS_CATEGORIES_DROPDOWN,
  GET_SOS_ZONES_DROPDOWN,
  UPDATE_SOS_PROVIDERS_STATUS,
  ADD_SOS_PROVIDER,
  UPDATE_SOS_PROVIDER,
  UPDATE_SOS_ZONES_STATUS,
  GET_SOS_ZONES,
  UPDATE_SOS_ZONE,
  ADD_SOS_ZONE,
  GET_SOS_MEMBERS,
  UPDATE_SOS_MEMBER_STATUS,
  ADD_SOS_MEMBER,
  UPDATE_SOS_MEMBER,
  GET_SOS_PROVIDERS_DROPDOWN,
  UPDATE_CIRCULARFENCE,
  GET_CIRCULARFENCE_DATA,
  ADD_CIRCULARFENCE,
  GET_ROUTEFENCE_DATA,
  ADD_ROUTEFENCE,
  GET_GEOFENCE_DEVICES,
  UPDATE_GEOFENCE_DEVICE_STATUS,
  ADD_GEOFENCE_DEVICE,
} from "../actions/addOnsTypes";

const initialState = {
  getAreafence: [],
  addAreafence: [],
  updateAreafence: [],
  getCircularfence: [],
  updateCircularfence: [],
  addCircularfence: [],
  getRoutefence: [],
  addRoutefence: [],
  getSosCategories: [],
  updateSosCategoriesStatus: [],
  addSosCategory: [],
  updateSosCategory: [],
  getSosProviders: [],
  sosCategoriesDropdown: [],
  updateSosProvidersStatus: [],
  getSosZones: [],
  updateSosZonesStatus: [],
  addSosZone: [],
  updateSosZone: [],
  getSosMembers: [],
  updateSosMemberStatus: [],
  addSosMember: [],
  updateSosMember: [],
  sosProvidersDropdown: [],
  getGeoFenceDevices: [],
  updateGeofenceDeviceStatus: [],
  addGeofenceDevice: [],
};
const getAreaFenceReducer = (state = initialState, action) => {
  const { type, payload } = action;
  // console.log("payload", payload);
  switch (type) {
    case GET_AREAFENCE_DATA:
      return {
        ...state,
        getAreafence: payload,
      };
    case UPDATE_AREAFENCE:
      return {
        ...state,
        updateAreafence: payload,
      };
    case ADD_AREAFENCE:
      return {
        ...state,
        addAreafence: payload,
      };
    default:
      return state;
  }
};
const getCircularFenceReducer = (state = initialState, action) => {
  const { type, payload } = action;
  // console.log("payload", payload);
  switch (type) {
    case GET_CIRCULARFENCE_DATA:
      return {
        ...state,
        getCircularfence: payload,
      };
    case UPDATE_CIRCULARFENCE:
      return {
        ...state,
        updateCircularfence: payload,
      };
    case ADD_CIRCULARFENCE:
      return {
        ...state,
        addCircularfence: payload,
      };
    default:
      return state;
  }
};
const getRouteFenceReducer = (state = initialState, action) => {
  const { type, payload } = action;
  // console.log("payload", payload);
  switch (type) {
    case GET_ROUTEFENCE_DATA:
      return {
        ...state,
        getRoutefence: payload,
      };
    case ADD_ROUTEFENCE:
      return {
        ...state,
        addRoutefence: payload,
      };
    default:
      return state;
  }
};
const getSosCategoriesReducer = (state = initialState, action) => {
  const { type, payload } = action;
  // console.log("payload", payload);
  switch (type) {
    case GET_SOS_CATEGORIES:
      return {
        ...state,
        getSosCategories: payload,
      };
    case UPDATE_SOS_CATEGORIES_STATUS:
      return {
        ...state,
        updateSosCategoriesStatus: payload,
      };
    case ADD_SOS_CATEGORY:
      return {
        ...state,
        addSosCategory: payload,
      };
    case UPDATE_SOS_CATEGORY:
      return {
        ...state,
        updateSosCategory: payload,
      };
    case GET_SOS_CATEGORIES_DROPDOWN:
      return {
        ...state,
        sosCategoriesDropdown: payload,
      };
    default:
      return state;
  }
};
const getSosProvidersReducer = (state = initialState, action) => {
  const { type, payload } = action;
  // console.log("payload", payload);
  switch (type) {
    case GET_SOS_PROVIDERS:
      return {
        ...state,
        getSosProviders: payload,
      };
    case UPDATE_SOS_PROVIDERS_STATUS:
      return {
        ...state,
        updateSosProvidersStatus: payload,
      };
    case ADD_SOS_PROVIDER:
      return {
        ...state,
        addSosProvider: payload,
      };
    case UPDATE_SOS_PROVIDER:
      return {
        ...state,
        updateSosProvider: payload,
      };
    case GET_SOS_PROVIDERS_DROPDOWN:
      return {
        ...state,
        sosProvidersDropdown: payload,
      };
    default:
      return state;
  }
};
const getSosZonesReducer = (state = initialState, action) => {
  const { type, payload } = action;
  // console.log("payload", payload);
  switch (type) {
    case GET_SOS_ZONES:
      return {
        ...state,
        getSosZones: payload,
      };
    case UPDATE_SOS_ZONES_STATUS:
      return {
        ...state,
        updateSosZonesStatus: payload,
      };
    case GET_SOS_ZONES_DROPDOWN:
      return {
        ...state,
        sosZonesDropdown: payload,
      };
    case ADD_SOS_ZONE:
      return {
        ...state,
        addSosZone: payload,
      };
    case UPDATE_SOS_ZONE:
      return {
        ...state,
        updateSosZone: payload,
      };
    default:
      return state;
  }
};
const getSosMembersReducer = (state = initialState, action) => {
  const { type, payload } = action;
  // console.log("payload", payload);
  switch (type) {
    case GET_SOS_MEMBERS:
      return {
        ...state,
        getSosMembers: payload,
      };
    case UPDATE_SOS_MEMBER_STATUS:
      return {
        ...state,
        updateSosMemberStatus: payload,
      };
    case ADD_SOS_MEMBER:
      return {
        ...state,
        addSosMember: payload,
      };
    case UPDATE_SOS_MEMBER:
      return {
        ...state,
        updateSosMember: payload,
      };
    default:
      return state;
  }
};
const getGeofenceDevicesReducer = (state = initialState, action) => {
  const { type, payload } = action;
  // console.log("payload", payload);
  switch (type) {
    case GET_GEOFENCE_DEVICES:
      return {
        ...state,
        getGeoFenceDevices: payload,
      };
    case UPDATE_GEOFENCE_DEVICE_STATUS:
      return {
        ...state,
        updateGeofenceDeviceStatus: payload,
      };
    case ADD_GEOFENCE_DEVICE:
      return {
        ...state,
        addGeofenceDevice: payload,
      };
    default:
      return state;
  }
};

export {
  getAreaFenceReducer,
  getSosCategoriesReducer,
  getSosProvidersReducer,
  getSosZonesReducer,
  getSosMembersReducer,
  getCircularFenceReducer,
  getRouteFenceReducer,
  getGeofenceDevicesReducer,
};
